export default __webpack_public_path__ + "static/media/intrusion_survey_figure.5d8df459.png";